import ContactForm from "./ContactForm";
import { Card, IconButton } from "components/common";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import React from 'react';

const NewContact = () => {
  const navigate = useNavigate()

  const handleCancel = () => {
    navigate(-1)
    return null
  }

  return (
    <Card padding="lg" className="tw-text-sm">
      <div className="tw-flex tw-justify-between tw-items-center tw-border-b tw-border-solid tw-border-slate-200 tw-pb-3">
        <h5 className="tw-mb-0 tw-font-semibold">New Contact</h5>
        <IconButton
          onClick={() => navigate(-1)}
          variant="secondary"
          size="sm"
          icon={<FaArrowLeft size={12} />}
        />
      </div>
      <div className="tw-mt-3">
        <ContactForm handleCancel={handleCancel}/>
      </div>
    </Card>
  )
}

export default NewContact
